import { getRequest,postRequest } from "@/services";
//我的奖励
export const getMyPrizes = params =>
  postRequest("/psbcNewCustomer/queryMyPrize", params);
//查询报名奖励
export const joinPrizeInfo = params =>
  postRequest("/psbcNewCustomer/joinPrizeInfo", params);
//报名活动
export const joinActivity = params =>
  postRequest("/psbcNewCustomer/joinActivity", params);
//获取用户登陆信息
export const queryUserInfo = params =>
  getRequest("/psbcNewCustomer/queryUserInfo", params);
//端外获取用户登陆信息
export const queryUserInfoOut = params =>
getRequest("/psbcNewCustomer/queryUserInfoOut", params);
//领取第二次奖励
export const get2ndPrize = params =>
  postRequest("/psbcNewCustomer/get2ndPrize", params);
//获取验证码
export const getCode = params => 
  postRequest("/CarbonMessage/SendMsg.do", params);
//查询抽奖次数
export const queryLeftTicket = params => 
  postRequest("/psbcNewCustomer/queryLeftTicket", params);
//查询抽奖次数
export const queryTicket = params => 
  postRequest("/psbcNewCustomer/queryTicket", params);
//抽奖
export const luckDraw = params => 
  postRequest("/psbcNewCustomer/go", params);
//兑换
export const exchange = params => 
  postRequest("/psbcNewCustomer/exchangeLotteryNumber", params);
//领取地铁授权奖励
export const getAuthPrize = params => 
  postRequest("/psbcNewCustomer/getAuthPrize", params);
//核销奖品
export const writeOffReward = params =>
  postRequest(
    `/psbcNewCustomer/writeOffTicket?code=${params.code}&id=${params.id}`
  ).then(res => res);